import { useCallback, useEffect, useRef } from "react";
import { InfoMessageType } from "src/SharedComponents/InfoBar/InfoBar";
import { LicenseType, useDistributorLicenseService } from "./useDistributorLicenseService";
import { logger } from "src/Utils/LoggerService/LoggerService";
import { usePartnerInfo } from "../usePartnerInfoContext";
import { useGetDistributorInfoWrapper } from "../useGetDistributorInfo/userGetDistributorInfoWrapper";
import { useTranslation } from "react-i18next";

export const useDistributorLicenseServiceWrapper = () => {
    const {t} = useTranslation();
    const { assignLicenseToClinic, unassignLicenseFromPartner, reqestError, reqestLoading, reqestResponse } = useDistributorLicenseService();
    const { setInfobar, setLoader, reset } = usePartnerInfo();
    const { getDistributorInfo } = useGetDistributorInfoWrapper();
    const infoMessage = useRef('');
    const clinicid = useRef('');
    useEffect(() => {
        if(reqestError !== '') {
           logger.logError(JSON.stringify(reqestError))
           setInfobar({message:reqestError,messageType: InfoMessageType.error })
        }
    }, [reqestError, setInfobar])
    useEffect(() => {
       setLoader(reqestLoading)
    },[reqestLoading, setLoader])
    
    useEffect(() => {
       if(reqestResponse) {
            logger.logInformation(infoMessage.current + `Clinic Id is ${clinicid.current}`)
            setInfobar({message:infoMessage.current, messageType: InfoMessageType.success})
            getDistributorInfo();
       }
    }, [reqestResponse, getDistributorInfo, setInfobar])


    const assignLicenseClinic = useCallback((licenseType:LicenseType, clinicId:string, entitlementId:string, clinicName: string, distributorId:string) => {
        reset();
        clinicid.current = clinicId;
        assignLicenseToClinic(entitlementId, clinicId, distributorId);
        if(licenseType === 0){
            infoMessage.current = t('AssignAuraAppLicenseSuccessMsg', {entitlementId: entitlementId, clinicName: clinicName});
        }
        else{
            infoMessage.current = t('AssignAuraSuiteLicenseSuccessMsg', {entitlementId: entitlementId, clinicName: clinicName});
        }
    },[assignLicenseToClinic, reset, t]) 

    const unassignLicenseClinic = useCallback((licenseType:LicenseType, clinicId:string, entitlementId:string, clinicName: string, distributorId:string) => {
        reset();
        clinicid.current = clinicId;
        unassignLicenseFromPartner(licenseType, entitlementId, clinicId, distributorId);
        infoMessage.current = t('UnassignLicenseSuccessMsg', {entitlementId: entitlementId, clinicName: clinicName});
    },[unassignLicenseFromPartner, reset, t])

    return {reqestResponse, assignLicenseClinic, unassignLicenseClinic}
} 